const APP_ID = process.env.INTERCOM_APP_ID

function Intercom(...args) {
  if (APP_ID) {
    window.Intercom(...args)
  }
}

// INTERCOM INJECT LIB CODE
{
  /* eslint-disable */
  let w = window; let ic = w.Intercom; if (typeof ic === "function") { ic('reattach_activator'); ic('update', intercomSettings); } else {
    let d = document; let i = function () { i.c(arguments) }; i.q = []; i.c = function (args) { i.q.push(args) }; w.Intercom = i; function l() {
      let s = d.createElement('script'); s.type = 'text/javascript'; s.async = true;
      s.src = 'https://widget.intercom.io/widget/' + APP_ID;
      let x = d.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x);
    } if (w.attachEvent) { w.attachEvent('onload', l); } else { w.addEventListener('load', l, false); }
  }
}

export function boot(user) {
  Intercom('boot', {
    sidx_version: 3,
    app_id: APP_ID,
    user_hash: user.intercom_user_hash,

    ...user.intercom_data,
  })
}

export function shutdown() {
  Intercom('shutdown')
}


// WEBPACK FOOTER //
// client/intercom.js